// polyfill for old browsers that don't support startsWith
if (!String.prototype.startsWith) {
    String.prototype.startsWith = function(searchString, position) {
        position = position || 0;
        return this.indexOf(searchString, position) === position;
    };
}

// Address console warnings about non-passive event listeners
// https://stackoverflow.com/questions/46094912/added-non-passive-event-listener-to-a-scroll-blocking-touchstart-event
['touchmove', 'touchstart', 'wheel'].forEach(event => {
    jQuery.event.special[event] = {
        setup: function( _, ns, handle ){
            if (ns.indexOf('noPreventDefault') > -1) {
                this.addEventListener(event, handle, { passive: false });
            } else {
                this.addEventListener(event, handle, { passive: true });
            }
        }
    };
});

function checkOrigin (environment) {
    return ['stage', 'production'].indexOf(environment) > -1;
}

const ROLE_ID_TO_GAINSIGHT_ATTRIBUTE_NAME = {
    7:  'RoleCustomer',
    1:  'RoleEmployee',
    22: 'RoleToolkit',
    2:  'RoleAdmin',
    14: 'RoleUserRoleManager',
    5:  'RoleUserManager',
    33: 'RoleLocationManager',
    31: 'RoleServiceAdvisor',
    19: 'RoleCustomerConfirmer',
    4:  'RoleOperationsManager',
    36: 'RoleDisposeVehicle'
};

var noop        = angular.noop,
    copy        = angular.copy,
    isFunction  = angular.isFunction,
    isArray     = angular.isArray,
    isObject    = angular.isObject;

angular.module('dealerware.web.components',[]);
angular.module('dealerware.web.smartling',[]);
angular.module('dealerware.web.content',[]);
angular.module('dealerware.web.data',[]);
angular.module('dealerware.web.filters',[]);
angular.module('dealerware.web.services',[]);

angular.module('dealerware', [
    'ngSanitize',
    'ui.router',
    'ui.grid',
    'ui.grid.selection',
    'ui.grid.exporter',
    'ui.grid.resizeColumns',
    'ui.grid.moveColumns',
    'ngFileUpload',
    'mobility.framework',
    'dealerware.layout',
    'dealerware.navigation',
    'dealerware.page',
    'mobility.web.core.components',
    'mobility.web.core.content',
    'mobility.web.core.data',
    'mobility.web.core.services',
    'mobility.web.core',
    'dealerware.config',
    'dealerware.web.components',
    'dealerware.web.smartling',
    'dealerware.web.content',
    'dealerware.web.data',
    'dealerware.web.filters',
    'dealerware.web.services',
    'md.data.table',
    'ngMaterial',
    'mdColors',
    'ngAnimate',
    'ngMap',
    'ngMessages',
    'ngResource',
    'anim-in-out',
    'vAccordion',
    'swaggerUi',
    'ngCsv',
    'wipImageZoom',
    'dw-angular-datadog'
])
.constant('$uiWindowSizeConfig', {
    screenSmMin: 0,
    screenSmMax: 567,
    screenMdMin: 568,
    screenMdMax: 767,
    screenLgMin: 568,
    screenLgMax: 1023,
    screenXlMin: 1024,
    screenXlMax: -1
})
.constant('$environmentNames', {
    dev: 'dev',
    qa: 'qa',
    prod: 'production',
})
.config([
    'datadogProvider',
    'DatadogClientToken',
    'DatadogApplicationId',
    'AppConfig',
    function(datadogProvider, DatadogClientToken, DatadogApplicationId, appConfig) {
        datadogProvider
            .config({
                clientToken: DatadogClientToken,
                applicationId: DatadogApplicationId,
                appVersion: appConfig.version,
                environment: appConfig.environment
            });
    }
])
.config(
    function($httpProvider) {
        $httpProvider.interceptors.push('$dealerwareHttpInterceptor');
    }
)
.config(function($mdIconProvider) {
    $mdIconProvider
        .defaultIconSet('/fonts/mdi.svg');
})
.config([
    '$mobilityCompanyAuthenticationProvider',
    function ($mobilityCompanyAuthenticationProvider) {
        $mobilityCompanyAuthenticationProvider.configure({
            selectCompanyState: 'root.private.application.chooseLocation'
        });
    }
])
.config([
    '$mobilityAuthenticationProvider',
    'MobilityAuthenticationStrategyProvider',
    function ($mobilityAuthenticationProvider, MobilityAuthenticationStrategyProvider) {
        MobilityAuthenticationStrategyProvider.configure({
            "deleteCookies": ["XSRF-TOKEN", "_silvercar.com_session"],
            "loginEndpoint": "/api/v1/users/signin.json",
            "loginMethod": "POST",
            "authTokenStorageKey": "auth_token",
            "authTokenHeaderKey": "Authorization",
            "userIdStorageKey": "user_id"
        });
    }
])
.config(function ($mdThemingProvider) {
    var dealerwarePrimary = {
        '50': '#71bad4',
        '100': '#F0F1F2',
        '200': '#4aa7c8',
        '300': '#102a3e',
        '400': '#348cab',
        '500': '#2d81ca',
        '600': '#286c83',
        '700': '#225c70',
        '800': '#3174ae',
        '900': '#163c49',
        'A100': '#424E52',
        'A200': '#98cde0',
        'A400': '#abd7e6',
        'A700': '#102c35',
        'contrastDefaultColor': 'light',    // whether, by default, text (contrast)
                                            // on this palette should be dark or light
    };

    $mdThemingProvider.definePalette('dealerwarePrimary', dealerwarePrimary);

    var dealerwareAccent = {
        '50': '#2283a4',
        '100': '#2694ba',
        '200': '#2aa4cf',
        '300': '#3bafd7',
        '400': '#51b8db',
        '500': '#66c0e0',
        '600': '#90d2e8',
        '700': '#a5daed',
        '800': '#bae3f1',
        '900': '#d0ecf5',
        'A100': '#a2a2a2',
        'A200': '#F0F1F2',
        'A400': '#66c0e0',
        'A700': '#e5f4fa',
        'contrastDefaultColor': 'dark',    // whether, by default, text (contrast)
                                            // on this palette should be dark or light
        'contrastDarkColors': ['50', '100', //hues which contrast should be 'dark' by default
        '200', '300', '400', 'A100'],
        'contrastLightColors': undefined

    };

    $mdThemingProvider.definePalette('dealerwareAccent', dealerwareAccent);

    var dealerwareWarn = {
        '50': '#fbafa6',
        '100': '#fa998e',
        '200': '#f98375',
        '300': '#f86d5d',
        '400': '#f75744',
        '500': '#f6412c',
        '600': '#f52b14',
        '700': '#e5210a',
        '800': '#cd1d09',
        '900': '#b41a08',
        'A100': '#fcc5bf',
        'A200': '#fddbd7',
        'A400': '#fef1f0',
        'A700': '#9c1607',
        'contrastDefaultColor': 'light',    // whether, by default, text (contrast)
                                            // on this palette should be dark or light
        'contrastDarkColors': ['50', '100', //hues which contrast should be 'dark' by default
        '200', '300', '400', 'A100'],
        'contrastLightColors': undefined
    };

    $mdThemingProvider.definePalette('dealerwareWarn', dealerwareWarn);


    var dealerwareBackground = {
        '50': '#ffffff',
        '100': '#ffffff',
        '200': '#ffffff',
        '300': '#ffffff',
        '400': '#ffffff',
        '500': '#ffffff',
        '600': '#ffffff',
        '700': '#ffffff',
        '800': '#ffffff',
        '900': '#ffffff',
        'A100': '#ffffff',
        'A200': '#ffffff',
        'A400': '#ffffff',
        'A700': '#ffffff'
    };

    $mdThemingProvider.definePalette('dealerwareBackground', dealerwareBackground);

   $mdThemingProvider.theme('default')
       .primaryPalette('dealerwarePrimary')
       .accentPalette('dealerwareAccent')
       .warnPalette('dealerwareWarn');
})
.directive(
    'scrolldirective', ['$window', 'AppConfig', 'MicroFrontendOrigin',
    function ($window, appConfig, MicroFrontendOrigin) {
        var isStageOrProd = checkOrigin(appConfig.environment);
        var targetOrigin = isStageOrProd ? MicroFrontendOrigin : '*';

        return {
            link: function(scope, elem, attrs) {
                elem.bind('wheel', function () {
                    var offset = $window.pageYOffset;

                    if (appConfig.embeddedMode) {
                        window.parent.postMessage({
                            type: 'scroll',
                            offset: offset
                        }, targetOrigin);
                    }
                });
            }
        };
}])
.run([
    '$rootScope', '$window', '$cookies', '$timeout', 'CurrentUser', 'Location', '$state', 'AppConfig', 'MicroFrontendOrigin', 'RoundValues', '$location',
    function($rootScope, $window, $cookies, $timeout, CurrentUser, Location, $state, appConfig, MicroFrontendOrigin, RoundValues, $location) {

        $rootScope.convertLitersToGallons = function(value) {
            var newValue = parseFloat(value) * 0.264172;
            return parseFloat(newValue.toFixed(2));
        }

        $rootScope.calculateFuelLevel = function(fuel, capacity) {
            var currentFuel = parseFloat(fuel) || 0;
            var fuelCapacity = $rootScope.convertLitersToGallons(parseFloat(capacity));
            var fuelDecimal = currentFuel / fuelCapacity;

            // Truncate fuel level to 3 decimal places without rounding
            var fuelLevel = RoundValues.percentage(fuelDecimal, 1000, Math.trunc);
            var fuelFraction = fuelLevel.toFractionString(16, false);

            if (fuelLevel > 1 || fuelFraction === '1') {
                fuelFraction = 'Full Tank';
            } else if (fuelLevel < 0 || fuelFraction === '0') {
                fuelFraction = 'Empty';
            }

            return fuelFraction;
        }

        var isStageOrProd = checkOrigin(appConfig.environment);

        function successCallback (lastPathname) {
            if (lastPathname === '/login' || lastPathname === '/chooseLocation' || !lastPathname) {
                $state.go('shortcuts.dashboard');
            } else {
                $location.path(lastPathname);
            }
        }

        function errorCallback (err) {
            // console.log('ERROR', err);
        }

        function loadCurrentUser (lastPathname) {
            CurrentUser.loadCurrentUser({
                successCallback: function () {
                    successCallback(lastPathname);
                },
                errorCallback: errorCallback
            });
        }

        function mapGainsightRoles (rolesList) {
            const gainsightRoles = {
                'RoleCustomer': false,
                'RoleEmployee': false,
                'RoleToolkit': false,
                'RoleAdmin': false,
                'RoleUserRoleManager': false,
                'RoleUserManager': false,
                'RoleLocationManager': false,
                'RoleServiceAdvisor': false,
                'RoleCustomerConfirmer': false,
                'RoleOperationsManager': false,
                'RoleDisposeVehicle': false
            };
            for (let role of rolesList) {
                if (ROLE_ID_TO_GAINSIGHT_ATTRIBUTE_NAME[role.id] !== undefined) {
                    gainsightRoles[ROLE_ID_TO_GAINSIGHT_ATTRIBUTE_NAME[role.id]] = true
                }
            }
            return gainsightRoles
        }

        function handleMessage (event) {
            var user = event.data.user;
            var location = event.data.location;
            var lastPathname = event.data.lastPathname;
            var isMessageValid = event.data.type === 'auth';
            var shouldUpdateLanguage = event.data.type === 'languageChanged'

            if (shouldUpdateLanguage) {
                $window.localStorage.setItem('language', event.data.language);
            }

            if (isStageOrProd) {
                isMessageValid = isMessageValid && event.origin === MicroFrontendOrigin;
            }

            if (isMessageValid) {
                $window.localStorage.setItem('mobility_authentication_strategy_used', 'MobilityAuthenticationStrategy');
                $window.localStorage.setItem('auth_token', user.authToken);
                $window.localStorage.setItem('user_id', user.id);
                $window.localStorage.setItem('onboarding', event.data.onboarding || false);

                $cookies.put('auth_token', user.authToken);
                $cookies.put('user_id', user.id);
                $cookies.put('location_id', location.id);

                Location.load(location.id)
                    .then(function() {
                        loadCurrentUser(lastPathname);
                    });
            }
        }

        $window.addEventListener('message', handleMessage);

        $rootScope.$on('$userAuthLocationChanged', function(event, locationData) {
            let location = locationData.location
            let baseUserAttributes = {
                "id": CurrentUser.user.data.id,
                "email": CurrentUser.user.data.email,
                "accountId": location.id
            };
            let rolesMapped = CurrentUser.user.data.roles_mapped || [];
            let userRoleAttributes = mapGainsightRoles(rolesMapped);
            let userAttributes = $.extend({}, baseUserAttributes, userRoleAttributes);

            aptrinsic("identify", userAttributes, {
                "id": location.id,
                "name": location.name,
                "city": location.address.city,
                "postalCode": location.address.zip,
                "stateCode": location.address.state
            });
        });

        $rootScope.$on('$viewContentLoaded', function() {
            $window.scrollTo(0, 0);
        });

        if (! $rootScope.$stateChangeSuccess) {

            $rootScope.$stateChangeSuccess =

                $rootScope.$on('$stateChangeSuccess', function () {

                    var previousRoute = $window.location.hash.substr(1);

                    // But it takes a tick for the window.history to change, so wait until the current route is there.
                    $timeout(function () {

                        var newHash = $window.location.hash.substr(1);
                        var targetOrigin = isStageOrProd ? MicroFrontendOrigin : '*';

                        if (appConfig.embeddedMode) {
                            if (window.self === window.top) {
                                window.location.replace(MicroFrontendOrigin + '/#' + newHash);
                            } else {
                                window.parent.postMessage({
                                    type: 'routing',
                                    hash: newHash
                                }, targetOrigin);
                            }
                        }

                        // Trigger route change GA tracking.
                        $rootScope.$broadcast('triggerGoogleAnalyticsTrackingEvent', {
                            type  : 'page',
                            route : {
                                old: previousRoute,
                                new: newHash
                            }
                        });
                    });
            });
        }
    }
]);
